import { useEffect, useState, useCallback } from "react";

const KEY = "autobahn_theme";

const getInitialTheme = () => {
  if (typeof window === "undefined") return "light";
  const saved = localStorage.getItem(KEY);
  if (saved === "light" || saved === "dark") return saved;
  if (window.matchMedia?.("(prefers-color-scheme: dark)").matches) return "dark";
  return "light";
};

export const useCustomerTheme = () => {
  const [theme, setThemeState] = useState(getInitialTheme);

  const setTheme = useCallback((next) => {
    localStorage.setItem(KEY, next);
    setThemeState(next);
  }, []);

  const toggleTheme = useCallback(() => {
    setTheme(theme === "dark" ? "light" : "dark");
  }, [theme, setTheme]);

  // Reflect user's system preference only if they've never picked manually
  useEffect(() => {
    const mm = window.matchMedia?.("(prefers-color-scheme: dark)");
    if (!mm) return;
    const handler = (e) => {
      const saved = localStorage.getItem(KEY);
      if (saved !== "light" && saved !== "dark") {
        setThemeState(e.matches ? "dark" : "light");
      }
    };
    mm.addEventListener?.("change", handler);
    return () => mm.removeEventListener?.("change", handler);
  }, []);

  return { theme, setTheme, toggleTheme };
};
